import Vue from 'vue'
import App from '../components/filters-with-list/App.vue'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

document.addEventListener('DOMContentLoaded', () => {
    const app = new Vue({
        render: h => h(App, { props: { filters: filters, config: listConfig, locale: locale, configTexts: configTexts } })
    }).$mount('#filters-with-list')
})